import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deleteOptionGroup = async (optionGroupId: string): Promise<void> => {
  const url = `${API_URL}/option-groups/${optionGroupId}`;
  const res = await fetch(url, {
    method: 'DELETE',
  });
  if (res.status !== Status.NO_CONTENT) {
    throw new Error('Something went wrong whilst deleting the modifier group');
  }
};
